import Widget from "./Widget";
import sources from "../config/sources";
import { tmpl } from "../../templates/topwidget.js";
import { formatNumber, formatChange } from "../helpers/formatters";

export default class Top extends Widget {
  constructor(feed, dimension) {
    super();

    if (
      !Object.prototype.hasOwnProperty.call(sources, feed) ||
      !Object.prototype.hasOwnProperty.call(sources[feed], dimension)
    ) {
      throw new Error(`Invalid feed/dimension: ${feed}/${dimension}`);
    }

    this.datasources = sources[feed][dimension];
  }

  init(el) {
    this.div = document.createElement("div");
    this.div.classList.add("sh-widget", "sh-top-widget", this._theme);
    this.div.innerHTML = tmpl;
    el.replaceWith(this.div);

    this.build();
  }

  build() {
    this.setTitle(this.datasources["top"]["title"]);
    this.div
      .querySelector('[data-element="title"]')
      .classList.add(this.datasources["top"]["field"]);
    const data = this.getData(DATA_URL + this.datasources["top"]["url"]);
    data.then((data) => {
      const stat = data.shift();
      this.div.querySelector('[data-element="field"]').innerHTML =
        stat[this.datasources["top"]["field"]];
      this.div.querySelector('[data-element="value"]').innerHTML = formatNumber(
        stat["value"]
      );

      const changeclass =
        stat["change"] > 0
          ? ["sh-pill-up", "sh-pill-red"]
          : ["sh-pill-down", "sh-pill-green"];

      this.div
        .querySelector('[data-element="change"]')
        .classList.add(...changeclass);
      this.div.querySelector('[data-element="change"]').innerHTML =
        formatChange(stat["change"]);

      this.clearLoading();
    });
  }
}
